import { render, staticRenderFns } from "./EditWordDocument.vue?vue&type=template&id=e705d726&"
import script from "./EditWordDocument.vue?vue&type=script&lang=js&"
export * from "./EditWordDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports